/**
 * @generated SignedSource<<d992461ea8898a69985af67ac4342089>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSidePanel_project$data = {
  readonly client: {
    readonly image_key: string | null | undefined;
    readonly name: string;
    readonly website: string | null | undefined;
  };
  readonly emoji: string | null | undefined;
  readonly id: number;
  readonly name: string;
  readonly notes_aggregate: {
    readonly aggregate: {
      readonly count: number;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSidePanelNotes_project">;
  readonly " $fragmentType": "ProjectSidePanel_project";
};
export type ProjectSidePanel_project$key = {
  readonly " $data"?: ProjectSidePanel_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSidePanel_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSidePanel_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "clients",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image_key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "notes_aggregate",
      "kind": "LinkedField",
      "name": "notes_aggregate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "notes_aggregate_fields",
          "kind": "LinkedField",
          "name": "aggregate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectSidePanelNotes_project"
    }
  ],
  "type": "projects",
  "abstractKey": null
};
})();

(node as any).hash = "e9f5a5f99e1b1ea82d1f509118b79921";

export default node;
